import Grid, { GridSpacing } from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';

type GridWrapperProps = {
  children: React.ReactNode;
  fixed?: boolean;
  narrow?: boolean;
  gutterBottom?: boolean;
  useBreakpoints?: boolean;
};

const GridWrapper = (props: GridWrapperProps) => {
  const { children, fixed = false, narrow = false, gutterBottom = false, useBreakpoints = true } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')) && useBreakpoints;
  const isTablet = useMediaQuery(theme.breakpoints.down('xl')) && useBreakpoints;

  let gridSpacing: GridSpacing = 3;
  if (fixed) {
    gridSpacing = 3;
  } else if (isMobile) {
    gridSpacing = 1;
  } else if (narrow || isTablet) {
    gridSpacing = 2;
  } else {
    gridSpacing = 3;
  }

  return (
    <Grid
      container
      spacing={gridSpacing}
      sx={{
        '& > .MuiGrid-item': {
          xs: {
            mb: gutterBottom ? 1 : null,
          },
        },
      }}
    >
      {children}
    </Grid>
  );
};

export default GridWrapper;
